import { render, staticRenderFns } from "./PreviewCommunityPostCardsComponent.vue?vue&type=template&id=a14b91e0&"
import script from "./PreviewCommunityPostCardsComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewCommunityPostCardsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports